import {
  createUserActionType,
  createUserFailureActionType,
  createUserSuccessActionType,
} from 'actions/Users/createUser';

const INITIAL_STATE = {
  isPending: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case createUserActionType:
      return {
        isPending: true,
      };
    case createUserSuccessActionType:
      return {
        isPending: false,
      };

    case createUserFailureActionType:
      return {
        isPending: false,
      };
    default:
      return state;
  }
};
